import { render, staticRenderFns } from "./corporateProfile.vue?vue&type=template&id=2d39bc6e&scoped=true&"
import script from "./corporateProfile.vue?vue&type=script&lang=js&"
export * from "./corporateProfile.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=2d39bc6e&prod&lang=scss&scoped=true&"
import style1 from "./corporateProfile.vue?vue&type=style&index=1&id=2d39bc6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39bc6e",
  null
  
)

export default component.exports